// src/components/Nodes/AddressServiceabilityModal.js

import React, { useState, useEffect } from 'react';
import { FaTimes, FaCopy } from 'react-icons/fa';

const AddressServiceabilityModal = ({ isOpen, onClose, nodeData, onSave }) => {
  // const [formData, setFormData] = useState(nodeData.data || {});
  const [inputFields, setInputFields] = useState(
    nodeData.parameters?.values || []
  );

  const predefinedFields = [
    { label: 'First Name', value: 'firstName' },
    { label: 'Last Name', value: 'lastName' },
    { label: 'Email', value: 'email' },
    { label: 'Phone', value: 'phone' },
    { label: 'City', value: 'city' },
    { label: 'State', value: 'state' },
    { label: 'ZIP', value: 'zip' },
    { label: 'Latitude', value: 'latitude' },
    { label: 'Longitude', value: 'longitude' },
  ];

  useEffect(() => {
    if (nodeData) {
      // setFormData(nodeData.data || {});
      setInputFields(nodeData.parameters?.values || []);
    }
  }, [nodeData]);

  const handleAddField = () => {
    setInputFields([...inputFields, { name: '', value: '' }]);
  };

  const handleRemoveField = (index) => {
    setInputFields(inputFields.filter((_, i) => i !== index));
  };

  const handleFieldChange = (index, fieldName) => {
    const newFields = [...inputFields];
    newFields[index] = { name: fieldName, value: '' };
    setInputFields(newFields);
  };

  const handleSave = () => {
    onSave({ inputFields });
    onClose();
  };

  const baseURL = 'https://example.com'; // Replace with actual base URL
  const generatedURL = `${baseURL}/workflow/self-service-signup/address`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(generatedURL);
    alert('URL copied to clipboard!');
  };

  return isOpen ? (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.modal}>
        <div style={modalStyles.header}>
          <h2>Address Serviceability</h2>
          <FaTimes onClick={onClose} style={modalStyles.closeIcon} />
        </div>

        <div style={modalStyles.scrollableContent}>
          {/* <label style={modalStyles.label}>Method</label>
          <select
            name="method"
            value="GET"
            disabled
            style={modalStyles.input}
          >
            <option value="GET">GET</option>
          </select>

          <label style={modalStyles.label}>URL</label>
          <div style={modalStyles.urlWrapper}>
            <input
              type="text"
              value={generatedURL}
              readOnly
              style={modalStyles.input}
            />
            <FaCopy onClick={copyToClipboard} style={modalStyles.copyIcon} />
          </div> */}

          <div style={modalStyles.inputFieldsWrapper}>
            <h3>Input Fields</h3>
            {inputFields.map((field, index) => (
              <div key={index} style={modalStyles.fieldRow}>
                <select
                  value={field.name || ''}
                  onChange={(e) => handleFieldChange(index, e.target.value)}
                  style={modalStyles.fieldSelect}
                >
                  <option value="" disabled>
                    Select a field
                  </option>
                  {predefinedFields.map((predefinedField) => (
                    <option
                      key={predefinedField.value}
                      value={predefinedField.value}
                      disabled={inputFields.some(
                        (f) => f.name === predefinedField.value
                      )}
                    >
                      {predefinedField.label}
                    </option>
                  ))}
                </select>
                <button
                  onClick={() => handleRemoveField(index)}
                  style={modalStyles.removeButton}
                >
                  Remove
                </button>
              </div>
            ))}
            {predefinedFields.length > inputFields.length && (
              <button onClick={handleAddField} style={modalStyles.addButton}>
                Add Field
              </button>
            )}
          </div>
        </div>

        <div style={modalStyles.actions}>
          <button onClick={handleSave} style={modalStyles.saveButton}>
            Save
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    width: '600px',
    padding: '20px',
    boxSizing: 'border-box',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    maxHeight: '80vh',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    position: 'relative',
  },
  closeIcon: {
    cursor: 'pointer',
    fontSize: '18px',
    color: '#333',
    position: 'absolute',
    top: '-10px',
    right: '-10px',
  },
  scrollableContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    overflowY: 'auto',
    flexGrow: 1,
    paddingRight: '10px',
  },
  label: {
    fontWeight: 'bold',
    marginBottom: '8px',
  },
  input: {
    width: '100%',
    padding: '8px',
    marginBottom: '12px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },
  urlWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  copyIcon: {
    cursor: 'pointer',
    fontSize: '18px',
    color: '#666',
    marginLeft: '8px',
  },
  inputFieldsWrapper: {
    marginTop: '20px',
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  },
  fieldSelect: {
    flexGrow: 1,
    padding: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginRight: '8px',
  },
  removeButton: {
    padding: '6px 12px',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#d9534f',
    color: '#fff',
    cursor: 'pointer',
  },
  addButton: {
    padding: '8px 16px',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#5bc0de',
    color: '#fff',
    cursor: 'pointer',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '20px',
  },
  saveButton: {
    padding: '10px 16px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    backgroundColor: 'var(--primary-color)',
    color: '#fff',
    textAlign: 'center',
  },
};

export default AddressServiceabilityModal;
